import { IkonNokta } from "@kantin/ui";

export function YonetimMarkasi() {
  return (
    <div className="yonetim-marka" aria-label="Kantin okul yönetimi">
      <span className="yonetim-marka-ikonu" aria-hidden="true">
        <IkonNokta boyut={22} />
      </span>
      <div>
        <p className="yonetim-marka-adi">
          Kantin<span>Yönetim</span>
        </p>
        <p className="yonetim-marka-alt">Okul yönetim paneli</p>
      </div>
    </div>
  );
}
